import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Api } from "../../utils/api";
import { Invoicexpress } from "../../utils/invoicexpress";
import RequestsHistoryTableRow from "./requests_history_table_row.component";

class RequestsHistoryTable extends React.Component {
  state = {
    loading: true,
  };

  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
    this.api = new Api();
    this.iexpress = new Invoicexpress();
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  /**
   *
   */
  componentDidMount() {
    this.setState({ loading: false });
  }

  render() {
    var { payments, classes, showAllColumns } = this.props;

    return (
      <div className="main-reqlist-container">
        <Paper className={classes.paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.head}></TableCell>
                <TableCell className={classes.head}>Fatura</TableCell>
                <TableCell
                  className={classes.head}
                  id="datatable-column-invoicedate"
                >
                  Data fatura
                </TableCell>
                <TableCell className={classes.head}>Valor (IVA)</TableCell>
                <TableCell className={classes.head}>Data cobrança</TableCell>
                <TableCell className={classes.head}>Modo pagamento</TableCell>
                <TableCell className={classes.head}>Status</TableCell>
                <TableCell className={classes.head}>Data Pagamento</TableCell>
                <TableCell className={classes.head}>Entidade</TableCell>
                <TableCell className={classes.head}>Equipamento</TableCell>
                <TableCell className={classes.head}>Distrito</TableCell>
                <TableCell className={classes.head}>Concelho</TableCell>
                <TableCell className={classes.head}>Emissor</TableCell>
                <TableCell className={classes.head}>Utente</TableCell>
                <TableCell className={classes.head}>Data Admissão</TableCell>
                <TableCell className={classes.head}>Mensalidade</TableCell>
                <TableCell className={classes.head}>Jóia</TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Consultor
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Gestor Zona
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Data Recepção
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Data Aceitação
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Data Confirmação
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Garantia
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Nota Crédito
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Data acerto
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Nova factura
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Data facturação
                </TableCell>
                <TableCell className={classes.head} hidden={!showAllColumns}>
                  Valor (IVA)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments &&
                payments.map((payment, idx) => (
                  <RequestsHistoryTableRow
                    payment={payment}
                    showAllColumns={showAllColumns}
                    invoices={this.props.invoices}
                    receipts={this.props.receipts}
                    idx={idx}
                  />
                ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  paper: {
    width: "100%",
    height: "400px",
    overflow: "scroll",
  },
  head: {
    backgroundColor: "#104363",
    color: "white",
    position: "sticky",
    top: 0,
    align: "left",
    zIndex: 1,
  },
});

RequestsHistoryTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(RequestsHistoryTable));
